import { categories, setBodyAreaSelected, staffId } from '../../utils/variables';
import { handleCheckProviders } from './movePages';
import { handleSelectProvider } from './providersListeners';

export function bodyAreaSelectionListeners() {
    // onclick input face
    const elementInputFace = document.querySelector(
        '.bodyAreaSelection__container .js-face-checkbox'
    );
    if (elementInputFace) {
        elementInputFace?.addEventListener('change', handleOnchangeInputFace);
    }

    // click continue button
    const buttonContinue = document.querySelector(
        '.bodyAreaSelection__container .bodySelectionContinue__btn'
    );
    buttonContinue?.addEventListener('click', handleOnclickContinueButton);

    // onchange input checkbox
    const inputs = document.querySelectorAll(
        '.bodyAreaSelection__container .form__row input[type=checkbox]'
    );

    inputs.forEach((input) =>
        input.addEventListener('change', handleOnchangeInputFace)
    );
}

const handleOnchangeInputFace = (event) => {
    if (event.target.classList.contains('js-face-checkbox')) {
        const bodyContainer = event.target.closest(
            '.bodyAreaSelection__container'
        );
        if (event.target.checked) {
            document
                .querySelector(
                    '.bodyAreaSelection__container .bodySelectionContinue__btn'
                )
                .classList.remove('disabled');

            bodyContainer.querySelector('.step__body').classList.add('zoom');
            bodyContainer.querySelector('.step__image').classList.add('zoom');
        } else {
            Array.from(
                bodyContainer.querySelectorAll(
                    '.bodyAreaSelection__container .step__col--face input[type="checkbox"]'
                )
            )?.forEach((item) => {
                item.checked = false;
            });
        }
    }

    if (getLengthInputChecked() > 0) {
        document
            .querySelector(
                '.bodyAreaSelection__container .bodySelectionContinue__btn'
            )
            ?.classList.remove('disabled');
    } else {
        document
            .querySelector(
                '.bodyAreaSelection__container .bodySelectionContinue__btn'
            )
            ?.classList.add('disabled');
    }

    if (document.querySelector('.step__image').classList.contains('zoom')) {
        document
            .querySelector(
                '.bodyAreaSelection__container .bodySelectionContinue__btn'
            )
            ?.classList.remove('disabled');
    }
};

const getLengthInputChecked = () => {
    const isFace = document
        .querySelector('.bodyAreaSelection__container .step__image')
        .classList.contains('zoom');
    if (isFace) {
        const inputs = document.querySelectorAll(
            '.bodyAreaSelection__container .step__col--face input[type="checkbox"]'
        );
        return Array.from(inputs)?.filter((input) => input.checked)?.length;
    }
    const inputs = document.querySelectorAll(
        '.bodyAreaSelection__container .step__col--body input[type=checkbox]'
    );
    return Array.from(inputs)?.filter((input) => input.checked)?.length;
};

const handleOnclickContinueButton = (event) => {
    if (event.target) {
        const bodyContainer = event.target.closest(
            '.bodyAreaSelection__container'
        );

        const bodyZoom = bodyContainer.querySelector('.step__body');
        const imageZoom = bodyContainer.querySelector('.step__image');

        if (
            bodyZoom.classList.contains('zoom') ||
            imageZoom.classList.contains('zoom')
        ) {
            bodyZoom.classList.remove('zoom');
            imageZoom.classList.remove('zoom');
        } else {
            const inputs = document.querySelectorAll(
                '.bodyAreaSelection__container .form__row input[type="checkbox"]'
            );

            let listCategorySelected = [];
            inputs.forEach((input) => {
                if (input.checked) {
                    const getCategory = categories.find(
                        (item) => item.name === input.dataset.category
                    );
                    listCategorySelected.push(getCategory);
                }
            });
            if (checkIsFace(listCategorySelected)) {
                listCategorySelected = listCategorySelected.filter(
                    (item) => item.name !== 'Face'
                );
            }
            setBodyAreaSelected(listCategorySelected);
            goToNextPage(event);
        }
    }
};

const goToNextPage = (e) => {
    staffId ? handleSelectProvider(e) : handleCheckProviders();
};

const checkIsFace = (cate) => {
    const listCategory = cate.map((item) => item.name);
    const inputs = document.querySelectorAll(
        '.bodyAreaSelection__container .step__col--face input[type="checkbox"]'
    );
    return Array.from(inputs).some((item) =>
        listCategory.includes(item.dataset.category)
    );
};
